export default __webpack_public_path__ + "static/char-t-20-zh-Hant-5f14e313891cb9037a394a4c91a02f80.png";